import { defineMessages } from 'react-intl';

export default defineMessages({
    billingSummaryTabs: {
        id: 'billing.billing-summary-page.Billing Summary',
        defaultMessage: 'Billing Summary'
    },
    failedToLoadPolices: {
        id: 'billing.billing-summary.Failed to load polices',
        defaultMessage: 'Failed to load polices'
    },
    sorryWeCanNotLoadYourPolicyInformationAtThisTime: {
        id: 'billing.billing-summary.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    noBillingData: {
        id: 'billing.billing-summary.no billing data',
        defaultMessage: 'No Billing Data Available at this time'
    },
    upcomingPayments: {
        id: 'portal.views.home-page-layout.Upcoming Payments',
        defaultMessage: 'Upcoming Payments',
    }, 
    billingpolicyNumber: {
        id: 'policy.common.directives.templates.billing-details.policyNumber',
        defaultMessage: 'Policy Number',
    },
    billingDetailsAmount: {
        id: 'policy.common.directives.templates.billing-details.Amount',
        defaultMessage: 'Amount',
    },
    billingDetailsDueDate: {
        id: 'policy.common.directives.templates.billing-details.Due Date',
        defaultMessage: 'Due Date',
    }, 
    billingDetailsPaymentSchedule: {
        id: 'portal.views.home-page-layout.Payment Schedule',
        defaultMessage: 'Payment Schedule',
    },
    noUpcomingPayments: {
        id: 'portal.views.home-page-layout.There are no Upcoming Payments for your PoliciesAccount',
        defaultMessage: 'There are no upcoming payments for your Policies/ Account',
    }, 
    BusinessOwners: {
        id: 'portal.views.home-page-layout.BusinessOwners',
        defaultMessage: 'Commercial Property Policy',
    }, 
    HOPHomeowners: {
        id: 'portal.views.home-page-layout.HOPHomeowners',
        defaultMessage: 'Residential Policy',
    }, 
    BusinessAuto: {
        id: 'portal.views.home-page-layout.BusinessAuto',
        defaultMessage: 'Auto Policy',
    }, 
    BP7BusinessOwners: {
        id: 'portal.views.home-page-layout.BP7BusinessOwners',
        defaultMessage: 'Farm Policy',
    }, 
    PersonalUmbrella: {
        id: 'portal.views.home-page-layout.PersonalUmbrella',
        defaultMessage: 'Umbrella Policy',
    }, 
    BusinessFleet: {
        id: 'portal.views.home-page-layout.BusinessFleet',
        defaultMessage: 'Fleet Policy',
    }
});
